import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';
import StatsClient from '@empathybroker/tsclient-stats';
import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { StatsParams } from '@empathybroker/tsclient-stats/dist/models/params/stats-params';
import { StatsError } from '@empathybroker/tsclient-stats/dist/models/stats-error';
import { StatsResponse } from '@empathybroker/tsclient-stats/dist/models/stats-response';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { FilterIdEnum, FilterTypeEnum } from '../../../enums';

import { ActionClass, ContextState, DateFilter, Filter, RealtimeFilter, RegularFilter } from '../../../models';

import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class FetchStatsReportAction implements ActionClass {

  public static execute({ rootGetters }: ActionContext<{}, any>,
    report: { id: StatsReportsIdsEnum, params: StatsParams }): Promise<StatsResponse | StatsError> {
    const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
    const statsClient: StatsClient = CONTAINER.get<(context: ContextState) => StatsClient>(TYPES.StatsClient)(context);
    const reportParams = FetchStatsReportAction.fillReportParamsWithContextState(report.params, context);
    return statsClient.getStatsReport(rootGetters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.token}`], report.id, reportParams);
  }

  private static fillReportParamsWithContextState(reportParams: StatsParams, context: ContextState): StatsParams {
    let contextParams: StatsParams = {
      startDate: undefined,
      endDate: undefined,
      filters: {}
    };
    Object.values(context.filters).forEach((filter: Filter) => {
      if (filter.config.enabled && (filter.config.id !== FilterIdEnum.COMPARE)) {
        contextParams = {
          [FilterTypeEnum.DATE]: () => FetchStatsReportAction.fillReportParamsWithDateFilter(contextParams, (filter as DateFilter)),
          [FilterTypeEnum.REALTIME]: () =>
            FetchStatsReportAction.fillReportParamsWithRealtimeFilter(contextParams, (filter as RealtimeFilter)),
          [FilterTypeEnum.REGULAR]: () => FetchStatsReportAction.fillReportParamsWithRegularFilter(contextParams, (filter as RegularFilter))
        }[filter.config.type]();
      }
    });

    return {
      ...contextParams,
      ...reportParams,
      filters: {
        ...contextParams.filters,
        ...reportParams.filters
      }
    };
  }

  private static fillReportParamsWithDateFilter(reportParams: StatsParams, filter: DateFilter): StatsParams {
    const startDateInMillis = filter.selectedValues[0];
    const endDateInMillis = filter.selectedValues[1];
    if (!!startDateInMillis && !!endDateInMillis) {
      reportParams.startDate = new Date(startDateInMillis);
      reportParams.endDate = new Date(endDateInMillis);
    }
    return reportParams;
  }

  private static fillReportParamsWithRealtimeFilter(reportParams: StatsParams, filter: RealtimeFilter): StatsParams {
    if (!!filter.selectedValues) {
      reportParams.endDate = new Date();
      reportParams.startDate = new Date(reportParams.endDate.getTime() - ((filter.selectedValues * 60) * 1000));
    }
    return reportParams;
  }

  private static fillReportParamsWithRegularFilter(reportParams: StatsParams, filter: RegularFilter): StatsParams {
    reportParams.filters[(filter.config.taggingId || filter.config.id)] = filter.selectedValues.map((selectedValue: string) => {
      const selectedValueConfig = filter.config.values.find((filterValueConfig: RegularFilterValueConfig) =>
        (filterValueConfig.id === selectedValue));
      return (selectedValueConfig.taggingId || selectedValueConfig.id);
    });
    return reportParams;
  }

}
